import React, { useState } from 'react';
import { Button, Card, Col, Container, Row, Nav, Navbar, Image, Table, Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ArrowUpRight, Check, X } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import moreBackground from './more-is-better.svg';
import premiumStars from './stars-premium.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentPlan, updateCurrentPlan, blankCurrentPlan, fetchPackagesDetail } from '../../redux/slices/EnhanceDisputeSlice';
import $ from 'jquery';
import NotyfContext from '../../contexts/NotyfContext';
import 'jquery-confirm/js/jquery-confirm';
import 'jquery-confirm/css/jquery-confirm.css';
import { callUserActvity, fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import EnhancedLPImage from '../../assets/img/enhanced-landing.png';
import EnhancedFactory from '../../assets/img/disputely-enhanced-factory.png';
import Waving from '../../assets/img/waving-hi.png';
import DiyStandard from '../../assets/img/standard-diy.png';
import WdfuStandard from '../../assets/img/standard-wd4u.png';
import { createDisputeLatter } from '../../redux/slices/CommonSlice';
import OneArmHold from '../../assets/img/one-arm-bot-sign.png';
import Experian from '../../assets/img/brands/experian.svg';
import Equifax from '../../assets/img/brands/equifax.svg';
import TransUnion from '../../assets/img/brands/transunion.svg';
import Loader from '../../components/Loader';
import CDIA from '../../assets/img/cdia.png';
import CFPB from '../../assets/img/cfpb.png';
import Creditor from '../../assets/img/creditor.png';
import USFTC from '../../assets/img/usftc.png';
import Chex from '../../assets/img/chexsystems.png';
import LexisNexis from '../../assets/img/lexisnexis.svg';
import Pacer from '../../assets/img/pacer.png';
import Joyride from 'react-joyride';
import InfoPopover from '../../components/new/InfoPopover';
import EnhancedStamp from './enhanced-stamp.png';

const EnhanceDisputeOnboarding = () => {
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: "Here is your progress bar -- you're already on step 2!",
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: <>And look we're already on a first name basis!</>,
      disableBeacon: true,
    },
    {
      target: '.third-step',
      content: 'Open Accounts refers to the total number of active credit accounts you currently have.',
      disableBeacon: true,
    },
    {
      target: '.fourth-step',
      content: 'Negative Accounts are credit accounts with late payments, defaults, or other negative marks on your credit report.',
      disableBeacon: true,
    },
    {
      target: '.fifth-step',
      content: 'Credit Utilization is the percentage of your available credit that you are currently using.',
      disableBeacon: true,
    },
    {
      target: '.sixth-step',
      content: 'Credit Inquiries are the number of times lenders have requested your credit report, which can impact your credit score.',
      disableBeacon: true,
    },
    {
      target: '.seventh-step',
      content: 'Credit History refers to the length of time you have had credit accounts open, which can affect your credit score.',
      disableBeacon: true,
    },
  ];

  React.useEffect(() => {
    setRun(true);
  }, []);

  const notyf = React.useContext(NotyfContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [planId, setPlanId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const packages = useSelector(state => state.enhanceDispute.packages);
  const mailingOption = useSelector(state => state.enhanceDispute.mailingOption);
  const packagesDetail = useSelector(state => state.enhanceDispute.packagesDetail);
  const currentPlan = useSelector(state => state.enhanceDispute.currentPlan);
  const currentPlanStatus = useSelector(state => state.enhanceDispute.currentPlanStatus);
  const currentPlanStatusMsg = useSelector(state => state.enhanceDispute.currentPlanStatusMsg);

  console.error(packages);

  React.useEffect(() => {
    dispatch(blankCurrentPlan());
    dispatch(fetchCurrentPlan());
    dispatch(fetchPackagesDetail());
  }, []);

  React.useEffect(() => {
    return () => {
      dispatch(blankCurrentPlan());
    };
  }, []);

  React.useEffect(() => {
    if (currentPlanStatus == 'updated.success' || currentPlanStatus == 'updated.failed') {
      notyf.open({
        type: currentPlanStatus == 'updated.success' ? 'success' : 'danger',
        message: currentPlanStatusMsg,
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });

      if (currentPlanStatus === 'updated.success') {
        setTimeout(() => {
          navigate('/dispute-center', { replace: true });
        }, 1000);
      }else{
        setIsSubmitting(false);
      }
    }
  }, [currentPlanStatus, dispatch]);

  const updatePlan = planId => {
    setPlanId(planId);
    setIsSubmitting(true);

    if (planId == 1 && mailingOption == 1) {
      dispatch(updateCurrentPlan({ planId, mailingOption }));
      dispatch(fetchNotification());
      dispatch(setNotifcationBedge(true));
    } else {
      const standard = planId == 1 && mailingOption == 2;
      dispatch(callUserActvity(`${standard ? 'Standard w/Mailing' : 'Enhanced Disputes'} Plan Selected`));
      notyf.open({
        type: 'success',
        message: `${standard ? 'Standard w/Mailing' : 'Enhanced Disputes'} Plan Selected`,
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
      setTimeout(() => {
        navigate(`/checkout/${standard ? 'standard' : 'enhanced'}`);
      }, 1000);
    }
  };

  if (isSubmitting) return <Loader />;

  return (
    <React.Fragment>
      <Helmet title='Enhanced Dispute' />
      <style>
        {`
          .steps {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            position: relative;
          }
          .step-button {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: none;
            background-color: var(--prm-gray);
            transition: .4s;
          }
          .step-button[aria-expanded="true"] {
            width: 25px;
height: 25px;
font-size: 12px;
          }
          .done {
            background-color: var(--prm-color);
            color: #fff;
          }
          .step-item {
            z-index: 10;
            text-align: center;
            margin-top: 1.5rem;
          }
          #progress {
            -webkit-appearance: none;
            position: absolute;
            width: 100%;
            z-index: 5;
            border: #C8CCDF dashed;
            border-width: 3px 0px 0px 0px;
            top: 6.75rem;
          }
          /* to customize progress bar */

          #progress::-webkit-progress-value {
            background-color: var(--prm-color);
            transition: .5s ease;
          }
          #progress::-webkit-progress-bar {
            background-color: var(--prm-gray);
          }
          .step-title {
            width: 120px;
            color: #7C84A5;
            font-weight: 400;
            text-align: center;
            margin-bottom:1.5rem;
          }
          .completed .step-title {
            text-align: center;
            font-weight: 500;
            color: #000E4E
          }
          .active .step-title {
            font-weight: 500;
            color: #0076FF
          }
          .shadow-more {
            box-shadow: 0 6px 40px 0 rgb(var(--bs-primary-rgb), 0.5) !important;
          }
          @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 790px !important;
                }
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 790px !important;
                }
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 790px !important;
                }
              }

          `}
      </style>
      <Container fluid className='container-fluid-1335 pb-5'>
        {/* <Joyride showSkipButton={true} locale={{ last: 'FINISH'}} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={true} /> */}
        <Row>
          <Col lg={12} className='first-step'>
            <h3>Disputes creating status</h3>
          </Col>
        </Row>
        <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='900px' activeStep={5} />

        <Row>
          <Col lg={12} className='mx-auto my-5'>
            <h1 className='text-center'>Upgrade Your Disputes</h1>
            <div className='text-medium-22 text-center'>You now have the option to boost the power of your letters by utilizing the advanced dispute tactics that our Credit Repair A.I. Tool provides!</div>
          </Col>
        </Row>
        <Row className='mx-auto d-flex flex-row'>
          {/* STANDARD DIY */}
          {mailingOption == 1 && (
            <Col md='6' className='bg-white mb-5 border-right-1 border-end d-flex flex-column pe-5'>
              <h2 className='text-center visibility-hidden'>⭐⭐⭐⭐⭐</h2>
              <div style={{ height: '170px' }}>
                <div className='text-center display-4 fw-bold'>Standard Tactics</div>
                <h4 className='text-center'>(Current Selection)</h4>
              </div>
              <div className='display-2 fw-bold text-center text-danger mt-5'>{packagesDetail.length > 0 && packagesDetail[0].total_letter}</div>
              <h2 className='text-center fw-600'>Total Dispute Letters</h2>
              <div className='text-center mb-3'>Self Serve - Process & mail Your Own letters</div>
              <div className='w-100'>
                <img src={DiyStandard} alt='DiyStandard' className='w-100' />
              </div>
              <Card.Header className='plan-images py-5 border-0 bg-white rounded-4' style={{ height: '410px' }}>
                <h3 className='mb-3 text-center'>
                  3 Bureau Disputes
                  <InfoPopover
                    iconMargin={0}
                    headerContent={null}
                    bodyContent={
                      <div>
                        {
                          <>
                            <Row className='d-flex flex-row justify-content-center align-items-center my-3'>
                              <Col xs={4}>
                                <Image src={Experian} alt='Experian' className='mx-auto w-100' />
                              </Col>
                              <Col xs={4}>
                                <Image src={Equifax} alt='Equifax' className='mx-auto w-100' />
                              </Col>
                              <Col xs={4}>
                                <Image src={TransUnion} alt='TransUnion' className='mx-auto w-100' />
                              </Col>
                            </Row>
                          </>
                        }
                      </div>
                    }
                  />
                </h3>
              </Card.Header>
              {mailingOption == 1 && (
                <Col xs={12} md={6} className='d-flex d-md-none flex-column justify-content-center order-last text-center position-relative'>
                  <h3 className='mb-5 text-secondary'>Standard 3 Bureau Disputes -- Self Serve</h3>
                  <h2 className='mt-3 text-secondary'>FREE</h2>
                </Col>
              )}
              {/* <Card className='mb-0 rounded-3 border border-4'>
                <Card.Header className='border-0 bg-white rounded-3' style={{ height: '40px' }}>
                  <div className='text-light-gray text-center p-0 fw-medium fs-18'>Your Current Plan</div>
                </Card.Header>
                <Card.Body className='bg-white p-0 rounded-3'>
                  <Navbar bg='white' expand='lg' className='p-0 shadow-none'>
                    <Container fluid>
                      <Navbar.Brand href='#home'>
                        <div className='bg-light-gray lh-1 p-1 rounded-5'>
                          <Check className='m-auto p-1 bg-white text-secondary rounded-circle h-auto border border-secondary border-1' width={30} height={30} strokeWidth={5} color={'var(--bs-secondary)'} />
                        </div>
                      </Navbar.Brand>
                      <Navbar.Brand className='me-auto h3 mb-0 text-secondary'>Standard</Navbar.Brand>
                      <Nav.Link href='#' disabled>
                        <Button variant='light-gray' className='text-secondary border-0 py-1 px-3'>
                          $ Free
                        </Button>
                      </Nav.Link>
                    </Container>
                  </Navbar>
                  <hr className='w-90 mx-auto opacity-25 text-light-gray' />
                  <Row>
                    <Col lg={10} className='mx-auto bg-light rounded-3 py-3'>
                      <p className='mb-1 fs-5 text-light-gray'>You will get</p>
                      <ul>
                        <li>{packagesDetail.length > 0 && packagesDetail[0].total_negative} Negative items (Dispute)</li>
                        <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Major Reporting Agencies (With me)</li>
                        <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Total Letters</li>
                        <li>Credit Bureau Disputes</li>
                        <li>Dispute Letter (Mail Only)</li>
                        <li>Personal Information Disputes Not Included</li>
                      </ul>
                    </Col>
                  </Row>
                </Card.Body>
              </Card> */}
            </Col>
          )}

          {/* STANDARD WITH MAILING */}

          {mailingOption == 2 && (
            <Col md='6' className='bg-white mb-5 border-right-1 border-end pe-5'>
              <h3 className='text-center visibility-hidden'>⭐⭐⭐⭐⭐</h3>
              <div style={{ height: '170px' }}>
                <div className='text-center display-4 fw-bold'>
                  Standard Tactics <br /> w/ Mailing
                </div>
                <h4 className='text-center'>(Current Selection)</h4>
              </div>
              <div className='display-2 text-center text-danger mt-5 fw-bold'>{packagesDetail.length > 0 && packagesDetail[0].total_letter}</div>
              <h2 className='text-center fw-600'>Total Dispute Letters</h2>
              <div className='text-center mb-3 fw-bold'>+ Expedited Processing & Mailing w/ Disputely</div>
              <div className='w-100'>
                <img src={WdfuStandard} alt='DiyStandard' className='w-100' />
              </div>
              <Card.Header className='py-5 border-0 bg-white rounded-4'>
                <h2 className='mb-3 text-center'>
                  3 Bureau Disputes
                  <InfoPopover
                    iconMargin={0}
                    headerContent={null}
                    bodyContent={
                      <div>
                        {
                          <>
                            <Row className='d-flex flex-column justify-content-center align-items-center my-3'>
                              <Col xs={12}>
                                <Image src={Experian} alt='Experian' className='mx-auto w-100' />
                              </Col>
                              <Col xs={12}>
                                <Image src={Equifax} alt='Equifax' className='mx-auto w-100' />
                              </Col>
                              <Col xs={12}>
                                <Image src={TransUnion} alt='TransUnion' className='mx-auto w-100' />
                              </Col>
                            </Row>
                          </>
                        }
                      </div>
                    }
                  />
                </h2>
              </Card.Header>

              {mailingOption == 2 && (
                <Col xs={12} md={6} className='d-flex d-md-none flex-column justify-content-center order-last text-center position-relative'>
                  <h3 className='mb-5 text-secondary'>Standard 3 Bureau Disputes, Mailed for you by Disputely</h3>
                  <h2 className='mt-3 text-secondary'>${packages[1]}</h2>
                </Col>
              )}

              {/* <Card className='mb-0 rounded-3 border border-4'>
                <Card.Header className='border-0 bg-white rounded-3' style={{ height: '40px' }}>
                  <div className='text-light-gray text-center p-0 fw-medium fs-18'>Your Current Plan</div>
                </Card.Header>
                <Card.Body className='bg-white p-0 rounded-3'>
                  <Navbar bg='white' expand='lg' className='p-0 shadow-none'>
                    <Container fluid>
                      <Navbar.Brand href='#home'>
                        <div className='bg-light-gray lh-1 p-1 rounded-5'>
                          <Check className='m-auto p-1 bg-white text-secondary rounded-circle h-auto border border-secondary border-1' width={30} height={30} strokeWidth={5} color={'var(--bs-secondary)'} />
                        </div>
                      </Navbar.Brand>
                      <Navbar.Brand className='me-auto h3 mb-0 text-secondary'>Standard with Mailing</Navbar.Brand>
                      <Nav.Link href='#' disabled>
                        <Button variant='light-gray' className='text-secondary border-0 py-1 px-3'>
                          ${packages[1]}
                        </Button>
                      </Nav.Link>
                    </Container>
                  </Navbar>
                  <hr className='w-90 mx-auto opacity-25 text-light-gray' />
                  <Row>
                    <Col lg={10} className='mx-auto bg-light rounded-3 py-3'>
                      <p className='mb-1 fs-5 text-light-gray'>You will get</p>
                      <ul>
                        <li>{packagesDetail.length > 0 && packagesDetail[0].total_negative} Negative items (Dispute)</li>
                        <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Major Reporting Agencies (With me)</li>
                        <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Total Letters</li>
                        <li>Credit Bureau Disputes</li>
                        <li>Dispute Letter (Mail Only)</li>
                        <li>Personal Information Disputes Not Included</li>
                      </ul>
                    </Col>
                  </Row>
                </Card.Body>
              </Card> */}
            </Col>
          )}

          <Col md='6' className='ps-0 ps-md-5'>
            <h3 className='text-center visibility-hidden'>⭐⭐⭐⭐⭐</h3>
            <div style={{ height: '170px' }}>
              <div className='text-center display-4 fw-bold'>ENHANCED Tactics</div>
              <div className='text-center display-1 fw-bold' style={{ color: '#0076FF' }}>
                MORE IS BETTER
              </div>
            </div>
            <div className='display-2 text-center text-danger fw-bold mt-5'>{packagesDetail.length > 0 && packagesDetail[1].total_letter}</div>
            <h2 className='text-center fw-600'>Total Dispute Letters</h2>
            <div className='text-center mb-3 fw-bold'>+ Expedited Processing & Mailing w/ Disputely</div>
            <Row className='d-flex flex-row'>
              <Col xs='4' className='mx-auto'></Col>
            </Row>
            <Image src={`${EnhancedFactory}`} alt='My Image' fluid />
            <Card.Header className=' pt-5 pb-3 border-0 bg-white rounded-4'>
              <h2 className='mb-3 text-center'>
                Expanded Bureau Disputes{' '}
                <InfoPopover
                  iconMargin={0}
                  headerContent={null}
                  bodyContent={
                    <div>
                      {
                        <>
                          <Row className='d-flex flex-row justify-content-center align-items-center my-3'>
                            <Col xs={4}>
                              <Image src={Experian} alt='Experian' className='mx-auto w-100' />
                            </Col>
                            <Col xs={4}>
                              <Image src={Equifax} alt='Equifax' className='mx-auto w-100' />
                            </Col>
                            <Col xs={4}>
                              <Image src={TransUnion} alt='TransUnion' className='mx-auto w-100' />
                            </Col>
                          </Row>
                          <Row className='d-flex flex-row justify-content-center align-items-center mb-3'>
                            <Col xs={4}>
                              <Image src={CDIA} alt='Experian' className='mx-auto w-100' />
                            </Col>
                            <Col xs={4}>
                              <Image src={CFPB} alt='Equifax' className='mx-auto w-100' />
                            </Col>
                            <Col xs={4}>
                              <Image src={Creditor} alt='TransUnion' className='mx-auto w-75' />
                            </Col>
                          </Row>
                          <Row className='d-flex flex-row justify-content-center align-items-center'>
                            <Col xs={4}>
                              <Image src={Chex} alt='Experian' className='mx-auto w-100' />
                            </Col>
                            <Col xs={4}>
                              <Image src={LexisNexis} alt='Equifax' className='mx-auto w-100' />
                            </Col>
                            <Col xs={4}>
                              <Image src={Pacer} alt='TransUnion' className='mx-auto w-100' />
                            </Col>
                          </Row>
                          <Row className='d-flex flex-row justify-content-center align-items-center'>
                            <Col xs='12' className='mx-auto my-4'>
                              <h3 className='text-center'>And More...</h3>
                            </Col>
                          </Row>
                        </>
                      }
                    </div>
                  }
                />
              </h2>
            </Card.Header>
            <Col>
              <h4>
                Personal Information Disputes <InfoPopover iconMargin={0} headerContent={null} bodyContent={<div>{<div className='d-block text-start'>Inaccurate and outdated information can be affecting your credit negatively removed.</div>}</div>} />
              </h4>
            </Col>
            <Col>
              <h4>
                Credit Inquiry Disputes <InfoPopover iconMargin={0} headerContent={null} bodyContent={<div>{<div className='d-block text-start'>Credit Inquiries can be the difference between you being approved or not REGARDLESS of your credit score. We will dispute all credit inquiries on your credit report (as long as they are not attached to an active account.)</div>}</div>} />
              </h4>
            </Col>
            <Col>
              <h4>
                Data Furnisher Disputes <InfoPopover iconMargin={0} headerContent={null} bodyContent={<div>{<div className='d-block text-start'>Want to Increase your Chances to get the absolute best results! Disputing with the Data Furnisher is important to increase your success chances.</div>}</div>} />
              </h4>
            </Col>
            <Col>
              <h4>
                Credit Bureau Disputes <InfoPopover iconMargin={0} headerContent={null} bodyContent={<div>{<div className='d-block text-start'>Just like the Standard disputes, we dispute all three credit reporting agencies using an even more enhanced version of our disputes to get the best results.</div>}</div>} />
              </h4>
            </Col>
            <Col>
              <h4>
                FCRA and FDCPA Violation disputes <InfoPopover iconMargin={0} headerContent={null} bodyContent={<div>{<div className='d-block text-start'>It's important to NEVER accept the investigation results by the Credit Reporting Agencies unless the outcome is "Deleted" or "Repaired" if after multiple attempts to remove the debt, they refuse to resolve the debt then we file Violation disputes with your local Attorney General, the Consumer Finance Protection Bureau, and the Federal Trade Commission.</div>}</div>} />
              </h4>
            </Col>
          </Col>
        </Row>
        <Row className='mt-5'>
          {mailingOption == 1 && (
            <Col xs={12} md={6} className='d-none d-md-flex flex-column justify-content-center order-last text-center position-relative'>
              <h3 className='mb-5 text-secondary'>Standard 3 Bureau Disputes, Mailed for you by Disputely</h3>
              <h2 className='mt-3 text-secondary'>FREE</h2>
            </Col>
          )}
          {mailingOption == 2 && (
            <Col xs={12} md={6} className='d-none d-md-flex flex-column justify-content-center order-last text-center position-relative'>
              <h3 className='mb-5 text-secondary'>Standard 3 Bureau Disputes, Mailed for you by Disputely</h3>
              <h2 className='mt-3 text-secondary'>${packages[1]}</h2>
            </Col>
          )}
          <Col xs={12} md={6} className='d-flex flex-column justify-content-center order-last text-center position-relative'>
            <div className='d-flex cardCoupon text-center'>
              <h1 class='mb-auto mt-3 text-white' style={{ zIndex: '9' }}>
                The Most Comprehensive Dispute Process Available
              </h1>
              <div className='imageCoupon'>
                <img src={EnhancedStamp} width='250' />
              </div>
              <div className='image2'>
                <img src={EnhancedStamp} width='350' />
              </div>
              <h2 className='mb-0 starburst burst p-5' id='burst-2' style={{ zIndex: '99' }}>
                <span className='p-5 text-white'>ONLY ${packages[2]}</span>
              </h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg='12' className='d-flex flex-column justfity-content-around py-5'>
            <style>
              {`

              .main {
	overflow-x: hidden !important;
}
            @keyframes seesaw {
  0%, 16.67%, 100% {
    transform: rotate(0deg);
  }
  8.33% {
    transform: rotate(5deg);
  }
  25%, 41.67% {
    transform: rotate(0deg);
  }
  33.33% {
    transform: rotate(-5deg);
  }
  50%, 66.67% {
    transform: rotate(0deg);
  }
}

.seesaw {
  animation: seesaw 2s ease-in-out infinite;
  transform-origin: center bottom;
}


          .starburst {
	font: 4em/1.4;
	background: #000e4e;
	width: 2.5em;
	height: 2.5em;
	text-align: center;
	color: #fff;
}

.starburst,
.starburst span {
  display: flex;
  align-items: center;
  justify-content: center;
}

.starburst span {
  width: 100%;
  height: 100%;
  background: inherit;
  transform: rotate(45deg);
}

.starburst:before,
.starburst:after ,
.starburst span:before,
.starburst span:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: rotate(30deg);
}

.starburst:after {
  transform: rotate(-30deg);
}

.starburst span:after {
  transform: rotate(30deg);
}
.starburst span:before {
  transform: rotate(-30deg);
}

.burst {
	position: absolute;
	top: 69%;
	margin-top: -1.25em;
	margin-left: -1.25em;
}

#burst-1 {
  left: 25%;
}

#burst-2 {
  left: 50%;
  transform: rotate(-45deg);
}
.cardCoupon {
  padding: 10px;
border-radius: 20px;
background: var(--bs-primary);
color: #fff;
height: 280px;
position: relative;
align-items: center;
justify-content: center;
border: 4px white dashed;
outline: 10px solid #0076FF;
}

.cardCoupon h1 {
  font-size: 48px;
  margin-bottom: 0px;
}

.cardCoupon span {
  font-size: 28px;
}

.imageCoupon {
  position: absolute;
  opacity: .1;
  left: 0;
  top: 0;
}

.image2 {
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: .1;
}

@media (max-width: 756) {
  left: 47%;
}

.plan-images {
 height: 410px;
}
              `}
            </style>
            <Button onClick={() => updatePlan(2)} variant='primary ms-auto px-5 py-3 w-md-40 w-100 mt-5' className='px-5 mx-auto seesaw' type='submit' size='lg'>
              Enhance My Disputes!
            </Button>
            <a onClick={() => updatePlan(1)} className='px-5 mt-5 mx-auto text-secondary text-center' type='button'>
              I'll stick to standard dispute tactics for now...
            </a>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default EnhanceDisputeOnboarding;
